<p>communication-details works!</p>
